






























































































import {Action, Mutation, State, Getter} from 'vuex-class';
import {Component, Vue} from 'vue-property-decorator';
import {
  FETCH_FUNCTIONALITY_LIST,
  CREATE_FUNCTIONALITY_LIST,
  GET_FUNCTIONALITY_LIST,
  GET_REGISTER_FUNCTIONALITY_FORM_VISIBILITY,
  UPDATE_REGISTER_FUNCTIONALITY_FORM_VISIBILITY,
  UPDATE_SELECTED_FUNCTIONALITY,
} from '@/modules/functionality/store';
import {FETCH_SYSTEM_LIST, CREATE_SYSTEM_LIST} from '@/modules/system/store';
import {IFunctionality} from '@/modules/functionality/models';
import {ISystem} from '@/modules/system/models';
import {RootState} from '@/store';
import {getEnabledCategories} from 'trace_events';
import {nameof} from 'ts-simple-nameof';

@Component
export default class extends Vue {
  public isLoading: boolean = false;
  public showRegisterForm: boolean = false;
  public search: string = '';
  public selected: any[] = [];
  public isOnlyActive = true;
  public headersStores: any[] = [
    {text: 'Sistema', value: 'system.nmsst'},
    {text: 'Nome', value: 'name'},
    {text: 'Contexto', value: 'contextdescription'},
    {text: 'Status', sortable: false, value: 'isactive'},
  ];

  public pagination: any = {
    sortBy: 'name',
    descending: false,
  };

  @Getter(GET_FUNCTIONALITY_LIST)
  public functionalities: IFunctionality[];

  @Getter(GET_REGISTER_FUNCTIONALITY_FORM_VISIBILITY)
  public showFunctionalityForm: boolean;

  @Action(FETCH_FUNCTIONALITY_LIST)
  private getAllFunctionalities: any;

  @Action(CREATE_FUNCTIONALITY_LIST)
  private setAllFunctionalities: any;

  @Action(UPDATE_SELECTED_FUNCTIONALITY)
  private setSelectedFunctionality: any;

  @Action(UPDATE_REGISTER_FUNCTIONALITY_FORM_VISIBILITY)
  private setShowFunctionalityForm: any;

  @Action(FETCH_SYSTEM_LIST)
  private getAllSystems: any;

  @Action(CREATE_SYSTEM_LIST)
  private setAllSystems: any;

  public created() {
    this.isLoading = true;

    this.getAllSystems()
      .then((ret: any) => this.setAllSystems(ret.data));

    this.getAllFunctionalities(this.isOnlyActive)
      .then((ret: any) => this.setAllFunctionalities(ret.data))
      .finally(() => this.isLoading = false);
  }

  public habilitarCadastro() {
    this.setShowFunctionalityForm(!this.showFunctionalityForm);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  public selectFunctionality(selectedFunctionality: IFunctionality) {
    this.setSelectedFunctionality(selectedFunctionality);
    this.setShowFunctionalityForm(true);
  }

  public getBadgeColor(icatv: boolean) {
    return icatv ? 'teal' : 'red';
  }

  public onFilter() {
    this.isLoading = true;

    this.getAllFunctionalities(this.isOnlyActive)
      .then((ret: any) => this.setAllFunctionalities(ret.data))
      .finally(() => this.isLoading = false);
  }
}
